// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b50e7ab5","239":"a17c693b","453":"85f2be50","455":"5b0343c1"}[chunkId] + ".chunk.js";
};